import TagManager from "react-gtm-module";
import { GTM_KEY_VALUE } from "../constants";

export const initializeTagManager = () => {
  TagManager.initialize({ gtmId: GTM_KEY_VALUE ?? "" });
};
